export default "__VITE_ASSET__e75b2a5d__"